// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2ao55","select":"Header_select__zuwlU","clinic":"Header_clinic__1kLmt"};